import { Post } from "../../../infra/data/api";
import DomainConstants from "../../../infra/data/domainConstants";
import CarteiraConstants from "carteira/src/infra/data/carteiraConstants";
import { PagamentoPixResponse, TransferenciaPixRequest } from "../../../types/_carteira/premiacao/transferenciaPixTypes";
import { IPagamentoService } from "domain/interfaces/_carteira/pagamento/IPagamentoService";

export class PagamentoService implements IPagamentoService {
  constructor() {
  }

  async Get(): Promise<boolean | Error> {
    //TODO GetAtivosByUsuario era Get, foi trocado por não existir Get
    return await Post(DomainConstants.apiDomain.campanhas.GetAllByUsuario, {/*data*/})
  }

  async TransferirPix(carteiraId: number, request: TransferenciaPixRequest): Promise<PagamentoPixResponse | Error> {
    const endpoint = CarteiraConstants.apiCarteira.carteira.transferirPix(carteiraId);
    return await Post(endpoint, request) as PagamentoPixResponse;
  }
}
